<template>
  <modal
    modal-key="resubscribe_with_pin"
    class-style="modal--welcomeback modal--zero-balance"
    body-style="invitation"
    @close="$emit('close')"
  >
    <template slot="header">
      <h1>{{getTranslations.home_modals_subscribe_re_optin_title}}</h1>
      <img class="pinicon" src="static/images/resubscribe_pin.png" alt="">
    </template>

    <template slot="body">
      <form action="">
        <input
          v-for="subscribeButton in subscribeButtonList"
          :key="subscribeButton.type"
          :value="getTranslations[subscribeButton.text]"
          class="btn2 btn2--std btn2--small btn btn--medium btn--main btn2--fixed"
          type="submit"
          @click.prevent="emitProceed(subscribeButton.type)"
        />
      </form>
    </template>
  </modal>
</template>

<script>
import {mapGetters} from 'vuex'
import Modal from './shared/GenericModal'
import {subscriptionTypeEnum} from '../../../common/mixins/subscription'

export default {
  name: 'SubscribeReoptin',
  emits: ['proceed', 'close'],
  components: {
    Modal
  },
  data () {
    return {
      subscribeButtonList: [
        {type: subscriptionTypeEnum.DAILY, text: 'home_modals_subscribe_re_optin_daily_subscription'},
        {type: subscriptionTypeEnum.ONE_TIME, text: 'home_modals_subscribe_re_optin_one_time_subscription'},
      ]
    }
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations'
    ])
  },
  methods: {
    emitProceed (subscriptionType) {
      this.$emit('proceed', subscriptionType)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/SubscribeReoptin.vue